// The odds, computed exactly - the house discipline from cant-stop's
// bustProbability: the bots' judgment and the engine's movement can never
// drift apart, because this enumerator drives every remaining-dice outcome
// through the SAME moveCamel the dispatch path uses.
//
// A leg has at most 5 dice left; every order matters (stacks!) and each die
// shows 1-3. Worst case 5! x 3^5 = 29,160 playouts of <=5 moves each -
// nothing, in exchange for exact numbers.
//
// The exact odds are for the BOTS (and tests). They are never shown to the
// human - the cant-stop line: surfacing arithmetic is fine, printing
// judgment plays the game for you. Feeling out the race IS the game.

import { moveCamel, rankCamels, raceWon } from './moves';
import { CAMELS, DIE_MIN, DIE_MAX } from './constants';

/**
 * Enumerates every way the current leg can finish.
 *
 * Returns per-camel probabilities of ending the leg first and second, the
 * probability the race ends this leg (with per-camel race-winner shares for
 * those endings), and the expected number of camel-unit landings on each
 * space (what a desert tile placement is worth).
 */
export const legOdds = (track, legDice, desert = {}) => {
  const pLeader = Object.fromEntries(CAMELS.map((c) => [c, 0]));
  const pSecond = Object.fromEntries(CAMELS.map((c) => [c, 0]));
  const pRaceWinner = Object.fromEntries(CAMELS.map((c) => [c, 0]));
  const landings = {};
  let pRaceEnds = 0;

  const walk = (currentTrack, dice, weight) => {
    if (dice.length === 0 || raceWon(currentTrack)) {
      const ranked = rankCamels(currentTrack);
      pLeader[ranked[0]] += weight;
      pSecond[ranked[1]] += weight;
      if (raceWon(currentTrack)) {
        pRaceEnds += weight;
        pRaceWinner[ranked[0]] += weight;
      }
      return;
    }
    const w = weight / (dice.length * (DIE_MAX - DIE_MIN + 1));
    for (let i = 0; i < dice.length; i += 1) {
      const rest = dice.slice(0, i).concat(dice.slice(i + 1));
      for (let value = DIE_MIN; value <= DIE_MAX; value += 1) {
        const { track: moved } = moveCamel(currentTrack, dice[i], value, desert);
        // Where did the unit land? (For desert EV: count the FIRST landing
        // spot, i.e. before any bounce - a tile triggers on the space it
        // sits on.) Recompute cheaply: the unit lands at from+value.
        const from = currentTrack.findIndex((s) => s.includes(dice[i]));
        const landed = Math.min(from + value, currentTrack.length - 1);
        landings[landed] = (landings[landed] || 0) + w;
        walk(moved, rest, w);
      }
    }
  };

  walk(track, legDice, 1);
  return {
    pLeader, pSecond, pRaceEnds, pRaceWinner, landings,
  };
};
